import * as React from 'react';
export const v0Svg = React.forwardRef(function v0SvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      style: {
        fill: 'light-dark(#000,#fff)',
      },
      d: 'M13.143 18.39V12.7h2.286v7.253c0 .855-.72 1.547-1.608 1.547-.423 0-.842-.157-1.142-.447L4 12.7h3.232zm11.643-7.89C26.56 10.5 28 11.885 28 13.594V19.3h-2.286v-5.036L20.482 19.3h5.232v2.2h-5.928c-1.776 0-3.215-1.385-3.215-3.094V12.7h2.286v5.053l5.25-5.053h-5.25v-2.2z',
    }),
  );
});
v0Svg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var v0 = {
  category: 'brand',
  colorable: false,
  name: 'v0',
  svg: v0Svg,
};
